module.exports = __webpack_public_path__ + "f27fb7242f5ce1bf14acadc21d8f980c.png";